import React from 'react';
import { useI18n } from '../context/I18nContext';
import './PlayerList.css';

function PlayerList({ players, onSelectPlayer, selectedPlayerId }) {
  const { language } = useI18n();
  const t = language === 'da'
    ? { onlinePlayers: 'Online spillere', ping: 'Ping', identifiers: 'identifikatorer' }
    : { onlinePlayers: 'Online Players', ping: 'Ping', identifiers: 'identifiers' };

  const sortedPlayers = [...players].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0));

  return (
    <div className="player-list">
      <h2>{t.onlinePlayers} ({sortedPlayers.length})</h2>
      <div className="players-container">
        {sortedPlayers.map((player) => (
          <div
            key={player.id}
            className={`player-card ${selectedPlayerId === player.id ? 'selected' : ''}`}
            onClick={() => onSelectPlayer(player)}
          >
            <div className="player-header">
              <span className="player-id">#{player.id}</span>
              <span className="player-name">{player.name}</span>
            </div>
            <div className="player-info">
              <span className="ping">{t.ping}: {player.ping}ms</span>
              <span className="identifiers-count">
                {player.identifiers?.length || 0} {t.identifiers}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PlayerList;
